import { DefaultContext } from "@apollo/client";
import { IRequest } from "../services/graphql/GraphqlService";
import { ApolloContextKey } from "../enums/ApolloContextKey";

export const getContextForRequest = (request: IRequest): DefaultContext => {
  return {
    [ApolloContextKey.CUSTOM_OPERATION_NAME]: request.name,
  };
};
